import React, { useEffect, useState } from "react";
import { getReportedPostDetails } from "../actions";
import ImgSlider from "../../../components/imgSlider";
import { useDispatch, useSelector } from "react-redux";
import DetailCard from "../../../components/siteDetailCard";
import ProperSpinner from "../../../components/spinner/ProperSpinner";
import ReportedByUserTableForPost from "../../../components/reportManagement/ReportedByUserTableForPost";
import {
  dateFormatter,
  isImage,
  isVideo,
} from "../../../utils/commonFunctions";
import ImagePreviewer from "../../../components/imgSlider/ImagePreviewer";

const PostDetails = ({ selectedPostId }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { postDetails: site } = useSelector(
    (state) => state.ReportReducer.post
  );

  useEffect(() => {
    setLoading(true);
    dispatch(getReportedPostDetails(selectedPostId, () => setLoading(false)));
  }, []);

  if (loading) {
    return <ProperSpinner />;
  }
  return (
    <div>
      <div>{<PostDetailsView site={site} />}</div>
      <div>
        <ReportedByUserTableForPost selectedPostId={selectedPostId} />
      </div>
    </div>
  );
};

const PostDetailsView = React.memo(({ site }) => {
  const [visible, setVisible] = useState(false);
  const [selectedPostIdx, setSelectedPostIdx] = useState(0);

  let images = [];
  let medias = [];
  site?.media?.forEach((curr_media, i) => {
    images.push(curr_media?.url);
    if (isImage(curr_media?.url)) {
      medias.push({
        src: curr_media?.url,
        alt: `Image ${i}`,
      });
    } else if (isVideo(curr_media?.url)) {
      const ext = curr_media?.url?.split(".").pop();
      medias.push({
        type: "video",
        width: 1280,
        height: 720,
        sources: [
          {
            src: curr_media?.url,
            type: `video/${ext}`,
          },
        ],
      });
    }
  });
  return (
    <div className="site-det-wrapper">
      <ImagePreviewer
        medias={medias}
        visible={visible}
        setVisible={setVisible}
        selectedPostIdx={selectedPostIdx}
        setSelectedPostIdx={setSelectedPostIdx}
      />
      <div className="site-content-container ">
        <div className="slider-container ">
          {site?.media?.length > 0 && (
            <ImgSlider
              Images={images}
              size={"small"}
              setSelectedPostIdx={setSelectedPostIdx}
              setVisible={setVisible}
              selectedPostIdx={selectedPostIdx}
            />
          )}
        </div>
        <div className="site-details-main-container">
          <div className="site-info-contaianer">
            <div className="site-details-container-1 ">
              <div className="personal-info-container">
                <h4 className="label-text heading text-underline ">
                  {"Post Details"}
                </h4>
                <div className="site-data-container">
                  <DetailCard data={site.title} label={"Title"} />
                  <DetailCard
                    data={
                      (site.description?.length > 50
                        ? site.description.substring(0, 50) + "..."
                        : site.description) || "N/A"
                    }
                    label={"Description"}
                  />
                  <DetailCard
                    data={site.status === 1 ? "Activate" : "Deactivate"}
                    label={"Status"}
                  />
                  <DetailCard
                    data={
                      site.userData?.firstName + " " + site.userData?.lastName
                    }
                    label={"Created By "}
                  />
                  <DetailCard
                    data={dateFormatter(site.createdAt)}
                    label={"Created At"}
                  />
                  <DetailCard data={site.reportCount} label={"Total Reports"} />
                  {site?.media &&
                    site.media.length > 0 &&
                    isImage(site.media[selectedPostIdx].url) && (
                      <>
                        <h4 className="label-text heading text-underline ">
                          {"Marine Information"}
                        </h4>
                        <DetailCard
                          data={site?.media[selectedPostIdx]?.commonName}
                          label="Common Name"
                        />

                        <DetailCard
                          data={`${site?.media[selectedPostIdx]?.score || "N/A"}`}
                          label="Score"
                        />
                        <DetailCard
                          data={site?.media[selectedPostIdx]?.type}
                          label="Type"
                        />
                        {site?.media[selectedPostIdx]?.inaturalistUrl && (
                          <DetailCard
                            label="Marine Image"
                            type="image"
                            data={site?.media[selectedPostIdx]?.inaturalistUrl}
                          />
                        )}
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

export default PostDetails;
